import { AnchorMenuItem } from '@ni/nimble-components/dist/esm/anchor-menu-item';
import { wrap } from '../utilities/react-wrapper';

export { type AnchorMenuItem };
export const NimbleAnchorMenuItem = wrap(AnchorMenuItem);
